import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';
import { GetAutoCompleteResultsResponse } from './types/get-autocomplete-results.type';
import { GetAutoCompleteRequest } from './types';


export const getAutoCompleteResults = async ({
	term,
	currentPage = 0,
	itemsPerPage = 20,
	origin = 'help',
}: GetAutoCompleteRequest): Promise<
	AxiosResponse<GetAutoCompleteResultsResponse>
> => {
	const response = await api.get('/searchv2/getautocompleteresults', {
		params: {
			term,
			currentPage,
			itemsPerPage,
			origin,
		},
	});

	return response;
};
